/**
 * Corre una tarea por cada elemento, pero con un TOPE de cuántas van a la vez.
 *
 * Para subir varias fotos: en serie, cada una espera a la anterior y cinco
 * fotos sobre datos móviles se hacen eternas; todas a la vez saturan la red
 * mala y fallan más. Un tope pequeño (tres) las solapa sin ahogar la conexión.
 *
 * Devuelve los resultados EN EL MISMO ORDEN que la entrada, pase lo que pase
 * con el orden en que terminan. Si una tarea lanza, la promesa lanza —igual que
 * un for que se corta— para no marcar como hecho lo que no subió.
 */
export async function mapConLimite<T, R>(
  items: T[],
  limite: number,
  tarea: (item: T, indice: number) => Promise<R>,
): Promise<R[]> {
  const resultados = new Array<R>(items.length)
  let siguiente = 0

  async function trabajador(): Promise<void> {
    while (true) {
      const i = siguiente++
      if (i >= items.length) return
      resultados[i] = await tarea(items[i], i)
    }
  }

  const cuantos = Math.max(1, Math.min(limite, items.length))
  await Promise.all(Array.from({ length: cuantos }, () => trabajador()))
  return resultados
}
